export type MonthlyPackage = {
  name: string;
  sessionsPerMonth: number;
  totalPrice?: number;
  discount?: number;
};

export type CoursePrice = {
  title: string;
  sessionType: "Grupă" | "Individual";
  duration: string;
  pricePerSession?: number;
  description: string;
  features: string[];
  packages?: MonthlyPackage[];
};

const groupPackages = (prices: [number, number, number]): MonthlyPackage[] => [
  { name: "Pachet 1", sessionsPerMonth: 4, totalPrice: prices[0] },
  { name: "Pachet 2", sessionsPerMonth: 8, totalPrice: prices[1] },
  { name: "Pachet 3", sessionsPerMonth: 12, totalPrice: prices[2] }
];

const individualPackages: MonthlyPackage[] = [
  { name: "Pachet 1", sessionsPerMonth: 4 },
  { name: "Pachet 2", sessionsPerMonth: 8, discount: 10 },
  { name: "Pachet 3", sessionsPerMonth: 12, discount: 15 }
];

export const languagePricing: Record<"group" | "individual", CoursePrice[]> = {
  group: [
    {
      title: "Clasele I-IV",
      sessionType: "Grupă",
      duration: "1,5 ore",
      description: "Cursuri de limbi străine în grupe mici.",
      features: ["Activități adaptate vârstei", "Materiale de studiu incluse"],
      packages: groupPackages([440, 800, 1130])
    },
    {
      title: "Clasele V-VIII",
      sessionType: "Grupă",
      duration: "1,5 ore",
      description: "Cursuri de limbi străine în grupe mici.",
      features: ["Consolidarea cunoștințelor", "Materiale de studiu incluse"],
      packages: groupPackages([520, 940, 1310])
    },
    {
      title: "Clasele IX-XII",
      sessionType: "Grupă",
      duration: "1,5 ore",
      description: "Cursuri de limbi străine în grupe mici.",
      features: ["Pregătire adaptată nivelului", "Materiale de studiu incluse"],
      packages: groupPackages([600, 1080, 1530])
    }
  ],
  individual: [
    {
      title: "Clasele I-VIII",
      sessionType: "Individual",
      duration: "1,5 ore",
      pricePerSession: 140,
      description: "Ședințe individuale de limbi străine.",
      features: ["Atenție individuală", "Program adaptat nevoilor elevului"],
      packages: individualPackages
    },
    {
      title: "Clasele IX-XII",
      sessionType: "Individual",
      duration: "1,5 ore",
      pricePerSession: 160,
      description: "Ședințe individuale de limbi străine.",
      features: ["Atenție individuală", "Program adaptat nevoilor elevului"],
      packages: individualPackages
    }
  ]
};

const schoolGroupPricing = (subject: "Limba română" | "Matematică"): CoursePrice[] => [
  {
    title: "Clasele V-VIII",
    sessionType: "Grupă",
    duration: "2 ore",
    pricePerSession: 180,
    description: `${subject} în grupe mici.`,
    features: ["Consolidarea materiei", "Pregătire pentru evaluări și examene"]
  },
  {
    title: "Clasele IX-XII",
    sessionType: "Grupă",
    duration: "2 ore",
    pricePerSession: 200,
    description: `${subject} în grupe mici.`,
    features: ["Consolidarea materiei", "Pregătire pentru evaluări și examene"]
  }
];

export const romanianPricing = schoolGroupPricing("Limba română");
export const mathPricing = schoolGroupPricing("Matematică");
